import { Box, Flex } from "@chakra-ui/react";
import { Col, Empty, Row } from "antd";
import {
  AreaComumHorarioItem,
  AreaComumDiaStatus,
} from "core/features/area-comum/typings";
import colors from "core/resources/theme/colors";
import moment from "moment";
import CardDefault from "ui/components/Cards/CardDefault";
import { MdInfoOutline } from "react-icons/md";
import { Tooltip } from "antd";

function FormHorario({
  value,
  onChange,
  dia,
  horarios,
}: {
  value: any;
  onChange: (inicio: string, fim: string) => any;
  dia: string;
  horarios: AreaComumHorarioItem[];
}) {
  return (
    <>
      <Box my="32px" fontSize={"18px"} fontWeight={"bold"}>
        Horários disponíveis para o dia {moment(dia).format("DD/MM/YYYY")}
      </Box>

      <Row gutter={[16, 16]}>
        {horarios.map((item, index) => {
          const isOcupado = item.status === AreaComumDiaStatus.Ocupado;
          const isBloqueado = item.status === AreaComumDiaStatus.Bloqueado;

          const isOcupadoOuBloqueado = isOcupado || isBloqueado;

          const hoverProp = isOcupadoOuBloqueado
            ? {
                _hover: {},
              }
            : undefined;

          return (
            <Col sm={6}>
              <Tooltip
                overlayInnerStyle={{ width: "max-content" }}
                placement="top"
                arrowPointAtCenter
                arrowContent
                color="#eff4ff"
                visible={item.motivo ? undefined : false}
                title={
                  <Flex flexDirection="column" color="black" p={2}>
                    {item.motivo}
                  </Flex>
                }
              >
                <CardDefault
                  cursor={isOcupadoOuBloqueado ? "not-allowed" : "pointer"}
                  key={index}
                  borderWidth={"1px"}
                  borderStyle={"solid"}
                  position="relative"
                  opacity={isOcupadoOuBloqueado ? 0.4 : 1}
                  borderColor={
                    item.inicio === value ? colors.primary : "transparent"
                  }
                  onClick={() =>
                    isOcupadoOuBloqueado
                      ? undefined
                      : onChange(item.inicio, item.fim)
                  }
                  {...hoverProp}
                >
                  {item.motivo ? (
                    <Flex position="absolute" top={"4px"} right={"4px"}>
                      <MdInfoOutline size={20} />
                    </Flex>
                  ) : null}
                  <Flex alignItems={"center"} justifyContent={"center"}>
                    {item.inicio.split(":").slice(0, 2).join(":")} -{" "}
                    {item.fim.split(":").slice(0, 2).join(":")}
                  </Flex>
                </CardDefault>
              </Tooltip>
            </Col>
          );
        })}
      </Row>

      {!horarios.length ? (
        <Empty description="Nenhum horário disponível" />
      ) : null}
    </>
  );
}

export default FormHorario;
